var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('hot-link',_vm._b({staticClass:"signup-button",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){$event.preventDefault();return _vm.openModal.apply(null, arguments)}}},'hot-link',_vm.link,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }